import { FC } from 'react'

interface IAddressDisplay {
  className?: string
  name: string
  address1: string
  address2?: string
  city: string
  state: string
  postalCode?: string
}

const AddressDisplay: FC<IAddressDisplay> = ({
  className,
  name,
  address1,
  address2,
  city,
  state,
  postalCode,
}) => (
  <div className={className}>
    <div>{name}</div>
    <div>{address1}</div>
    {address2 && <div>{address2}</div>}
    <div>{`${city}${!!state ? `, ${state}` : ''}${!!postalCode ? ` ${postalCode}` : ''}`}</div>
  </div>
)

export default AddressDisplay
